import { LoginForm } from "@/components/login-form"
import { AuthPageShell } from "@/components/auth/auth-page-shell"
import { useAuth } from "@/hooks/use-auth"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { resolvePostAuthRedirect } from "@/lib/auth-return"
import { useEffect } from "react"

export function LoginPage() {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (isAuthenticated) {
      const destination = resolvePostAuthRedirect({
        returnToParam: searchParams.get('returnTo'),
        stateFrom: (location.state as { from?: string } | null)?.from,
      })
      navigate(destination, { replace: true })
    }
  }, [isAuthenticated, location.state, navigate, searchParams])

  const handleLoginSuccess = () => {
    // Navigation will happen via useEffect when auth state changes
  }

  return (
    <AuthPageShell title="Sign in">
      <LoginForm onSuccess={handleLoginSuccess} />
    </AuthPageShell>
  )
}
